import { deepEquals } from '@nike/ciclp-utils';
import { createSelector } from 'reselect';
import { uniqueByValue } from '../../utils/uniqueByValue';
import { cardsSelector } from './getCardDataSelector';
import {
  countryCodeSelector,
  languageRegionHrefSelector,
} from '../state/stateSelector';
import cardMethods from '../../services/transforms/cardMethods';
import { urlsSelector } from './urlSelectors';

export const urlIngredientsSelector = createSelector(
  cardsSelector,
  countryCodeSelector,
  languageRegionHrefSelector,
  urlsSelector,
  (cards, countryCode, languageRegion, urls) => {
    if (!cards) return [];

    const getIngredients = card =>
      cardMethods[card.containerType].getUrlIngredients(
        card,
        countryCode,
        languageRegion,
      );
    const excludeList = urls.map(url => url?.[0]);
    const ingredientsFromCards = uniqueByValue(
      Object.values(cards).flatMap(getIngredients),
    );

    // filter out ingredients that are already in the exclude list using deepEquals
    return ingredientsFromCards.filter(
      item => !excludeList.some(ex => deepEquals(ex, item)),
    );
  },
);
